module.exports = ".row:nth-child(odd){\r\n    background: #ececec;   \r\n}\r\n\r\n.row{\r\n    padding: 1em 0px 0px 0px !important;\r\n}\r\n\r\n.mat-form-field-wrapper{\r\n    padding-bottom:0px !important;\r\n}\r\n\r\n.mandatory{\r\n    color:red;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/ultilities/office/office-form/office-form.component.css
// module id = ./src/app/ultilities/office/office-form/office-form.component.css
// module chunks = main